import React from "react";
import NoteTags from "../NoteTags";
import NoteStatus from "../NoteStatus";
import {Link} from "react-router";
import { linkForType } from "../notes";
import { cx } from "../../lib/ClassSet";
import styles from "./NoteView.module.scss"
import showdown from "showdown";

function formatUTC(value) {
  if (value == null) return "";
  return String(value).substr(0, 19).split("T").join(" @ ");
}

export default function NoteView({data}) {

  let converter = new showdown.Converter()
  let linkInfo = linkForType(data.get("foreignType"), data.get("foreignId"));

  let classNames = cx({
    "NoteView": true,
    [styles.withDescription]: data.get("descriptionHtml", "").length > 0
  })

  console.log("NoteView", data.get("descriptionHtml"), data.get("descriptionHtml", "").length);
  return (
    <div className={classNames}>
      <div className={styles.infoPanel}>
        <div className={styles.subject}>{data.get("title")}</div>
        <div className={styles.descriptionLegend}>More Information</div>
        <div className={styles.html} dangerouslySetInnerHTML={{__html: converter.makeHtml(data.get("descriptionHtml", ""))}} />
      </div>
      <table className="PropertiesList" style={{marginBottom: "10px"}}>
        <tbody>
          <tr>
            <th>Status</th>
            <td><NoteStatus status={data.get("status")} /></td>
          </tr>
          <tr>
            <th>Type</th>
            <td><Link to={linkInfo.get("path")}>{linkInfo.get("title")}</Link></td>
          </tr>
          <tr>
            <th>Tags</th>
            <td><NoteTags ids={data.get("tags")} /></td>
          </tr>
          <tr>
            <th>Created</th>
            <td>{formatUTC(data.get("insertedAt"))} by {data.get("createdByName")}</td>
          </tr>
          <tr>
            <th>Last Updated</th>
            <td>{formatUTC(data.get("updatedAt"))} by {data.get("updatedByName")}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
